import { defineMessages } from 'react-intl';

export default defineMessages({
    searchAddress: {
        id: 'addressstandardization.input.Search Address',
        defaultMessage: 'Search Address'
    },
    addressLine1: {
        id: 'addressstandardization.input.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'addressstandardization.input.Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    addressLine3: {
        id: 'addressstandardization.input.Address Line 3',
        defaultMessage: 'Address Line 3'
    },
    city: {
        id: 'addressstandardization.input.City',
        defaultMessage: 'City'
    },
    province: {
        id: 'addressstandardization.input.Province',
        defaultMessage: 'Province'
    },
    postalCode: {
        id: 'addressstandardization.input.Postal Code',
        defaultMessage: 'Postal Code'
    },
    addressType: {
        id: "addressstandardization.input.Address Type",
        defaultMessage: "Address Type"
    },
    description: {
        id: 'addressstandardization.input.Address Description',
        defaultMessage: 'Address Description'
    },
    licenseNum: {
        id: 'addressstandardization.input.License #',
        defaultMessage: 'License #'
    },
    licenseState: {
        id: 'addressstandardization.input.License State',
        defaultMessage: 'License State'
    },
    SSNNumber: {
        id: 'addressstandardization.input.SSN',
        defaultMessage: 'SSN'
    },
    FEINNumber: {
        id: 'addressstandardization.input.FIEN',
        defaultMessage: 'FIEN'
    }
})